export class FuncaoExercidaPrestacaoConta{
    public id: number;
    public id_funcao_exercida: number;
    public id_hipoteses: number;
    public id_prestacao_conta: number;
    public data_exclusao: Date; 
    public classe: string = "FuncaoExercidaPrestacaoContaDto";
}


// WEBPACK FOOTER //
// ./src/app/entity/funcao-exercida_prestacao_conta.model.ts